/* istanbul ignore file */
import {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common/dist/types/types';
import {ButtonOptionWidth} from '../../../constants';

export const getOptionsButtonsCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const {
    productPage_buttonOptionsVerticalPadding,
    productPage_buttonOptionsHorizontalPadding,
    productPage_buttonOptionsColumnsNumber,
    productPage_buttonOptionWidth,
  } = styleParams.numbers;

  const getButtonOptionsGridColumns = (): string => {
    return `repeat(${productPage_buttonOptionsColumnsNumber}, minmax(0, 1fr))`;
  };

  const getButtonOptionsPadding = (): string => {
    const isGridMode = productPage_buttonOptionWidth === ButtonOptionWidth.STRETCH;
    const horizontalPadding = isGridMode ? 8 : productPage_buttonOptionsHorizontalPadding;
    return `${productPage_buttonOptionsVerticalPadding}px ${horizontalPadding}px`;
  };

  return {
    buttonOptionsPadding: getButtonOptionsPadding(),
    buttonOptionsGridColumns: getButtonOptionsGridColumns(),
  };
};
